import React, { useState, useEffect, useRef } from 'react';
import {Util, FormProvider} from '@thinkwell/react.common';
import {AppProvider} from '@thinkwell/react.polaris';
import PasswordForm from '../PasswordForm';
import ProxyForm from './ProxyForm'

export default function ResetPassword(props) {
  Util.hideLoader();

  const data = {customer_id: props.customer_id}

  return (<AppProvider><FormProvider data={data}>
    <ProxyForm
    action="/account/reset"
    submitText="Reset Password"
    proxy={{action: '/accounts/reset_password', host: props.host, shop_name: props.shop_name}}>
      <input readOnly type="hidden" name="form_type" value="reset_customer_password" />
      <input readOnly type="hidden" name="id" value={props.customer_id} />
      <input readOnly type="hidden" name="token" value={props.token} />
      <PasswordForm withConfirmation
        names={{password: "customer[password]", password_confirmation: "customer[password_confirmation]"}}
      />
    </ProxyForm>
  </FormProvider></AppProvider>)
}
